/**
 * GeolocateItem
 * 
 * @Author: Focci
 * @Date: 2024-11-07 09:12:22
 * @Last Modified by: Focci
 * @Last Modified time: 2024-11-07 09:12:22
 */

// import PropTypes from 'prop-types'
// import useApp from '@hook/useApp'
import { useTranslations } from 'next-intl'
import { useCallback } from 'react'
import { useMapState } from '@comp/mapbox'
import OverallItemScoff, { OverallItemSwitch } from '../OverallItemScoff'
import GeolocateController from '../../GeolocateController'

export default function GeolocateItem() {
  const ts = useTranslations('search')
  const tm = useTranslations('mapbox')
  const mps = useMapState()

  const handleChange = useCallback((e) => {
    const status = e.target.checked ? 1 : 2
    mps.setSuburbShadow((prev) => ({ ...prev, manual: true, status }))
  }, [mps])

  const handleDisplaySuburbChange = useCallback((e) => {
    const hoverBoundary = e.target.checked
    mps.setSuburbShadow((prev) => ({ ...prev, hoverBoundary }))
  }, [mps])

  return (
    <OverallItemScoff title={ts('mapStyle')} expanding>
      <div className="flex flex-row-reverse justify-end gap-6">
        <GeolocateController small={true} />
      </div>
      <div className="mt-4">
        <OverallItemSwitch
          label={tm('displayShadow')}
          checked={mps.suburbShadow.status === 1}
          onChange={handleChange}
        />
      </div>
      <div className="mt-2">
        <OverallItemSwitch
          label={tm('displaySuburb')}
          checked={mps.suburbShadow.hoverBoundary}
          onChange={handleDisplaySuburbChange}
        />
      </div>
    </OverallItemScoff>
  )
}

// GeolocateItem.propTypes = {
//   className: PropTypes.string,
// }
